import React from "react";
import { useMediaQuery } from "react-responsive";
import { isMobileView } from "../../helpers/isMobileView";
import { useIsClient } from "../hooks/useIsClient";

type ChildrenProps = {
	children: React.ReactNode;
};

export const Mobile = ({ children }: ChildrenProps) => {
	const isClient = useIsClient();
	const isMobile = isMobileView();
	return isMobile && isClient ? children : null;
};

export const Default = ({ children }: ChildrenProps) => {
	const isClient = useIsClient();
	const isNotMobile = useMediaQuery({ minWidth: 768 });
	return isNotMobile && isClient ? children : null;
};
